module.exports = __webpack_public_path__ + "images/fafaad0c1a0198ed1e988f6bfed74975.jpg";